const actionSettings = {
	rerenderPrompts: true, // whether to re-render questions on problem types
};

export function getRerenderPrompts() {
	return actionSettings.rerenderPrompts;
}

export function setRerenderPrompts(bool) {
	actionSettings.rerenderPrompts = bool;
}

/**
 * A list of responses the teacher can give.
 */
const teacherResponses = {
	positive: [
		"That's right!",
		"Good job!",
		"Nice work!",
		"Awesome!",
		"You got it!",
		"Yep!",
	],
	negative: [
		"Not quite. Try again.",
		"Not quite. Give it another shot.",
		"Not quite. Keep trying.",
		"That doesn't look right to me. Try again.",
		"That doesn't look right to me. Give it another shot.",
		"That doesn't look right to me. Keep trying.",
	],
	repeat: [
		"You've already submitted that!",
		"I think you've submitted that already.",
		"I believe you've already tried that.",
		"I'm pretty sure you've submitted that already.",
	],
};

/**
 * Returns a random response from the teacherResponses object.
 * Key must be a key in this object, e.g. "positive" or "negative".
 *
 * @param {string} key Must be a key in teacherResponses.
 */
export function getRandomTeacherResponse(key) {
	if (key in teacherResponses) {
		const n = Math.floor(Math.random() * teacherResponses[key].length);
		return teacherResponses[key][n];
	} else {
		throw new Error(`${key} is not a key in the teacher response object.`);
	}
}
